import React from 'react';

interface GoalsProgressPageProps {
  user: any;
  coachMode?: boolean;
  clientId?: number;
}

export const GoalsProgressPage: React.FC<GoalsProgressPageProps> = ({ user, coachMode, clientId }) => {
  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="bg-gradient-to-r from-purple-500 to-purple-600 rounded-lg shadow-sm">
        <div className="px-6 py-8 sm:px-8">
          <h1 className="text-2xl font-bold text-white">
            Goals & Progress 🎯
          </h1>
          <p className="mt-2 text-purple-100">
            {coachMode 
              ? `Coaching goals and progress tracking for ${user?.full_name || user?.email}` 
              : `Client-determined goals and progress tracking for ${user?.fullName || user?.email}`
            }
          </p>
        </div>
      </div>

      {/* Coming Soon Content */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="card">
          <div className="card-header">
            <h3 className="text-lg font-medium text-gray-900">Custom Goal Setting</h3>
          </div>
          <div className="card-body">
            <div className="text-center py-8">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 rounded-full mb-4">
                <span className="text-3xl">🎯</span>
              </div>
              <h4 className="text-lg font-medium text-gray-900 mb-2">Client-Specific Goals</h4>
              <p className="text-sm text-gray-500 mb-4">
                Set personalized nutrition targets based on individual client needs, health conditions, and therapeutic requirements.
              </p>
              <div className="text-xs text-gray-400">Coming in Phase 2C</div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h3 className="text-lg font-medium text-gray-900">Progress Tracking</h3>
          </div>
          <div className="card-body">
            <div className="text-center py-8">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-4">
                <span className="text-3xl">📈</span>
              </div>
              <h4 className="text-lg font-medium text-gray-900 mb-2">Achievement Monitoring</h4>
              <p className="text-sm text-gray-500 mb-4">
                Track client progress toward goals with visual charts, milestone celebrations, and improvement insights.
              </p>
              <div className="text-xs text-gray-400">Coming in Phase 2C</div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h3 className="text-lg font-medium text-gray-900">Therapeutic Targets</h3>
          </div>
          <div className="card-body">
            <div className="text-center py-8">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
                <span className="text-3xl">⚕️</span>
              </div>
              <h4 className="text-lg font-medium text-gray-900 mb-2">Health-Specific Goals</h4>
              <p className="text-sm text-gray-500 mb-4">
                Set goals based on specific health conditions, deficiencies, or therapeutic protocols.
              </p>
              <div className="text-xs text-gray-400">Coming in Phase 2C</div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header">
            <h3 className="text-lg font-medium text-gray-900">Goal Templates</h3>
          </div>
          <div className="card-body">
            <div className="text-center py-8">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-yellow-100 rounded-full mb-4">
                <span className="text-3xl">📋</span>
              </div>
              <h4 className="text-lg font-medium text-gray-900 mb-2">Pre-built Goal Sets</h4>
              <p className="text-sm text-gray-500 mb-4">
                Quick-start templates for common conditions: diabetes, cardiovascular health, weight management, etc.
              </p>
              <div className="text-xs text-gray-400">Coming in Phase 2C</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};